import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Col, Tabs } from 'antd'
import CampaignHistory from './CampaignHistory'
import { useGlobalQuery } from 'hooks/useGlobalQuery'
import Loading from 'components/Utils/Loading'

const AppCampaigns = () => {
  const { isLoading } = useGlobalQuery()
  const history = useHistory()
  const location = useLocation()

  const getActiveKey = () => {
    if (
      location.pathname === '/app-campaigns' ||
      location.pathname === '/app-campaigns/new'
    )
      return 'history'
    const path = location.pathname.split('/')
    return path[path.length - 1]
  }

  const handleTabChange = (key: string) => {
    history.push(`/app-campaigns/${key}`)
  }

  useEffect(() => {
    if (location.pathname === '/app-campaigns') {
      history.replace('/app-campaigns/history')
    }
  }, [location.pathname, history])

  if (isLoading) return <Loading />

  return (
    <Col className='_mt-16' data-testid='app-campaigns'>
      <Tabs
        activeKey={getActiveKey()}
        onChange={handleTabChange}
        destroyInactiveTabPane={true}
      >
        <Tabs.TabPane tab='Campaign History' key='history'>
          <Col>
            <CampaignHistory isPublished={true} />
          </Col>
        </Tabs.TabPane>
        <Tabs.TabPane tab='Scheduled Campaigns' key='scheduled'>
          <Col>
            <CampaignHistory isPublished={false} />
          </Col>
        </Tabs.TabPane>
      </Tabs>
    </Col>
  )
}

export default AppCampaigns
